import { useWorkspaceStore } from 'store/workspace.store';

// !IMPORTANT: These flags are used to toggle features (small or big) on and off.
// This configuration is for use specifically for unique customers instead of a global change.

export const CUSTOMER_IDS = {
  BALANCE: 'ade7795b-da13-46ca-b505-a7d997cba3be',
  DURA: '2beb79ae-e1cd-4996-9916-b90933ecad77',
  FACILIO: '1918bf5d-b288-44b9-9122-e1118cad9f4f',
  FRONTLINE: 'b699d36b-87e8-48d0-b3ff-8f46ad29a72e',
  INVST: '977c1c75-ba19-4a03-91ff-e0226ea82d5a',
  KIVA: '1a4c6b94-9552-4690-b9a2-2f529d4ede3b',
  KIVA_STAGING: '4292f9cc-04ba-4a9c-9d11-6f191abf7275',
  RENTLY: '1bcb9eff-1143-4bc3-82b3-cb257fce74df',
  SIERRA: '5f5d62d2-b8b5-450e-9458-49efd22ea34a',
  SIERRA_STAGING: '57c25768-ad74-4a59-abc9-a6e2ea675477',
  BLUE_STAR: '8293a543-85c7-4b73-986b-c5b59ffe87e0',
  BLOOM: 'ce6d7442-94ff-4650-951d-3a1912575e44',
  JEEVES: '808e23e5-8459-4aa6-ae9d-5731a9ef0650',
} as const;

// Non-hook version for use in callbacks/queryFn
export const getCustomerFlags = (workspaceId: string | null) => {
  return {
    FF__IS_BALANCE_CUSTOMER: workspaceId === CUSTOMER_IDS.BALANCE,
    FF__IS_DURA_CUSTOMER: workspaceId === CUSTOMER_IDS.DURA,
    FF__IS_FACILIO_CUSTOMER: workspaceId === CUSTOMER_IDS.FACILIO,
    FF__IS_FRONTLINE_CUSTOMER: workspaceId === CUSTOMER_IDS.FRONTLINE,
    FF__IS_INVST_CUSTOMER: workspaceId === CUSTOMER_IDS.INVST,
    FF__IS_RENTLY_CUSTOMER: workspaceId === CUSTOMER_IDS.RENTLY,
    FF__IS_KIVA_CUSTOMER:
      workspaceId === CUSTOMER_IDS.KIVA ||
      workspaceId === CUSTOMER_IDS.KIVA_STAGING,
    FF__IS_SIERRA_CUSTOMER:
      workspaceId === CUSTOMER_IDS.SIERRA || // Production
      workspaceId === CUSTOMER_IDS.SIERRA_STAGING, // Staging
    FF__IS_BLUE_STAR_CUSTOMER: workspaceId === CUSTOMER_IDS.BLUE_STAR, // Demo
    FF__IS_BLOOM_CUSTOMER: workspaceId === CUSTOMER_IDS.BLOOM, // Demo
    FF__IS_JEEVES_CUSTOMER: workspaceId === CUSTOMER_IDS.JEEVES, // Demo
  };
};

export const useCustomerFeatureFlags = () => {
  const { workspace } = useWorkspaceStore();
  return getCustomerFlags(workspace?.id ?? null);
};
